// extracted by mini-css-extract-plugin
export default {"SimpleFeatureList":"SimpleFeatureList_SimpleFeatureList__gp8cW"};